<ng-container *transloco="let t">
    <div class="container">
        <div
            fxLayout="row wrap"
            fxLayoutAlign="space-around start"
            fxLayout.xs="column"
        >
            <div
                fxLayoutAlign="space-between center"
                fxFlex.xs="90%"
                fxLayout.xs="column"
                style="width: 100%"
            >
                <h1>{{ t("account.header.title") }}</h1>
                <button
                    mat-raised-button
                    color="accent"
                    (click)="goBack()"
                    class="go-back"
                >
                    <mat-icon aria-hidden="false" aria-label="Go Back"
                        >arrow_back</mat-icon
                    >
                    {{ t("shared.go-back") | uppercase }}
                </button>
            </div>
            <div
                fxFlex="940px"
                fxLayoutAlign="start center"
                fxFlex.xs="90%"
                fxFlex.sm="100"
            >
                <p style="margin: 1rem 0">
                    {{ t("account.header.sub-title") }}
                </p>
            </div>
        </div>

        <mat-card appearance="outlined">
            @if ((xSmall$ | async) === false) {
            <mat-sidenav-container>
                <mat-sidenav mode="side" opened>
                    <mat-nav-list>
                        <a
                            mat-list-item
                            [routerLink]="['/account/personal-information']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                        >
                            <mat-icon
                                mat-list-icon
                                svgIcon="lps-personal-info"
                            ></mat-icon>
                            {{ t("account.tab.personal-information") }}
                        </a>
                    </mat-nav-list>
                </mat-sidenav>
                <mat-sidenav-content>
                    <div style="padding: 0.5rem">
                        <router-outlet></router-outlet>
                    </div>
                </mat-sidenav-content>
            </mat-sidenav-container>
            } @else {
            <nav mat-tab-nav-bar>
                <a
                    mat-tab-link
                    routerLinkActive
                    #accountLink="routerLinkActive"
                    [routerLink]="['/account/personal-information']"
                    [active]="accountLink.isActive"
                >
                    <mat-icon
                        mat-list-icon
                        svgIcon="lps-personal-info"
                    ></mat-icon>
                    {{ t("account.tab.personal-information") }}
                </a>
            </nav>
            <router-outlet></router-outlet>
            }

            <!-- Mobile -->
        </mat-card>
    </div>
</ng-container>
